import { render } from "./TwCarouselDynamicSize.vue?vue&type=template&id=71853074"
import script from "./TwCarouselDynamicSize.vue?vue&type=script&lang=js"
export * from "./TwCarouselDynamicSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__